var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarketTracker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 418 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5390_26594)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.156 4.2478V155.044",
    stroke: "#EAE7ED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M221.059 4.2478V155.044",
    stroke: "#EAE7ED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M327.504 4.2478V155.044",
    stroke: "#EAE7ED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M384.5 48.8157C384.185 48.8157 384.498 49.6556 384.2 49.667C352.127 50.0323 369.152 69.0992 343.165 69.0992C317.178 69.0992 322.179 46.7256 295.947 46.7256C269.715 46.7256 281.957 82.1239 248.729 82.1239C215.502 82.1239 232.99 11.3274 201.512 11.3274C170.033 11.3274 185.772 54.8303 154.294 54.8303C122.815 54.8303 136.806 23.8041 107.076 23.8041C77.3464 23.8041 86.0904 74.236 61.6072 74.236C37.1239 74.236 38.7678 51.246 15.8934 49.2598C14.8616 49.1685 13.7773 49.1228 12.6406 49.1228",
    stroke: "url(#paint1_linear_5390_26594)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M384.501 107.328C383.904 107.328 377.946 107.146 383.298 107.611C365.496 107.043 365.927 96.5903 342.103 96.5903C318.279 96.5903 321.036 65.0731 294.701 65.0731C268.367 65.0731 266.612 107.395 247.3 107.395C227.988 107.395 222.722 83.5017 199.899 83.5017C177.076 83.5017 178.831 104.691 152.497 104.691C126.163 104.691 131.43 62.3009 105.096 62.3009C78.7617 62.3009 78.7617 92.5455 57.6944 92.5455C36.6271 92.5455 37.6203 78.8889 14.692 78.2299C14.1302 78.2072 14.7024 78.4425 14.1055 78.4425",
    stroke: "url(#paint2_linear_5390_26594)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M386.856 57.3452C390.407 57.3452 393.285 54.4925 393.285 50.9735C393.285 47.4545 390.407 44.6018 386.856 44.6018C383.306 44.6018 380.428 47.4545 380.428 50.9735C380.428 54.4925 383.306 57.3452 386.856 57.3452Z",
    fill: "url(#paint3_linear_5390_26594)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M386.856 113.982C390.407 113.982 393.285 111.13 393.285 107.611C393.285 104.092 390.407 101.239 386.856 101.239C383.306 101.239 380.428 104.092 380.428 107.611C380.428 111.13 383.306 113.982 386.856 113.982Z",
    fill: "url(#paint4_linear_5390_26594)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2129 55.9292C21.355 55.9292 24.7129 53.0765 24.7129 49.5575C24.7129 46.0385 21.355 43.1858 17.2129 43.1858C13.0708 43.1858 9.71289 46.0385 9.71289 49.5575C9.71289 53.0765 13.0708 55.9292 17.2129 55.9292Z",
    fill: "url(#paint5_linear_5390_26594)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2129 84.9558C21.355 84.9558 24.7129 82.1031 24.7129 78.5841C24.7129 75.0651 21.355 72.2124 17.2129 72.2124C13.0708 72.2124 9.71289 75.0651 9.71289 78.5841C9.71289 82.1031 13.0708 84.9558 17.2129 84.9558Z",
    fill: "url(#paint6_linear_5390_26594)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M208.791 4.2478V155.044",
    stroke: "#EAE7ED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M259.973 4.2478V155.044",
    stroke: "#EAE7ED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M311.906 4.2478V155.044",
    stroke: "#EAE7ED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5390_26594",
    x: 0,
    y: 0,
    width: 418,
    height: 168,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5390_26594"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5390_26594",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5390_26594",
    x1: 209,
    y1: 0,
    x2: 209,
    y2: 160,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA6FFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#711CF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5390_26594",
    x1: 198.57,
    y1: 11.3274,
    x2: 198.57,
    y2: 82.1239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BCDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1F5FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5390_26594",
    x1: 199.303,
    y1: 62.3009,
    x2: 199.303,
    y2: 107.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BCDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1F5FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5390_26594",
    x1: 393.285,
    y1: 57.3453,
    x2: 380.428,
    y2: 57.3453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#509FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BCDF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5390_26594",
    x1: 393.285,
    y1: 113.982,
    x2: 380.428,
    y2: 113.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#509FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BCDF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5390_26594",
    x1: 24.7129,
    y1: 55.9293,
    x2: 9.71289,
    y2: 55.9293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#509FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BCDF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5390_26594",
    x1: 24.7129,
    y1: 84.9559,
    x2: 9.71289,
    y2: 84.9559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#509FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BCDF7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketTracker);
export default __webpack_public_path__ + "static/media/market-tracker.bc16021b43ba6d83c6af673fda31f88e.svg";
export { ForwardRef as ReactComponent };